import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import './App.css';

function Barra() {
  return (
    <Navbar className="site-nav" expand="lg" sticky="top">
      <Navbar.Brand className="brand-mark" href="/">
        <img src="/images/png/jm.png" alt="Johnatan Mena" />
        <span>Johnatan Mena</span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="main-navbar" />
      <Navbar.Collapse id="main-navbar">
        <Nav className="nav-links ms-auto">
          <Nav.Link href="/">Inicio</Nav.Link>
          <Nav.Link href="/bio">Biografia</Nav.Link>
          <Nav.Link href="/experiencia">Experiencia</Nav.Link>
          <Nav.Link href="/contenido">Contenido</Nav.Link>
          <Nav.Link className="nav-cta" href="/curriculum">Curriculum</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Barra;
